import {
  mapState,
  mapActions,
} from 'vuex';

export default {

  data() {
    return {
      schemaLoaded: false,
    };
  },

  computed: {
    ...mapState({
      schemas: state => state.schemas.schemas,
    }),
  },

  methods: {
    ...mapActions(['getSchema']),

    async loadSchema(schema) {
      if (this.debug) { console.log(`${schema} schema requested!`); }
      if (Object.keys(this.schemas[schema]).length === 0) {
        try {
          if (this.debug) { console.log(`fetching ${schema} schema...`); }
          await this.getSchema({
            params: {
              schema,
            },
          });

          if (this.debug) { console.log(`${schema} fetched!`); }

          this.schemaLoaded = true;
          Bus.$emit('schema_loaded');
        } catch (error) {
          if (this.debug) { console.log(error); }
        }
      } else if (this.debug) {
        console.log(`${schema} schema already fetched!`);

        this.schemaLoaded = true;
        Bus.$emit('schema_loaded');
      }
    },
  },

  mounted() {
    Bus.$on('schema_loaded', () => {
      if (this.debug) { console.log('schemas-loader.schemas', this.schemas); }
    });

    Bus.$on('refresh_schema', (schema) => {
      this.loadSchema(schema);
    });

    Bus.$on('refresh_schemas', () => {
      this.loadSchema('forms');
    });
  },

  beforeDestroy() {
    Bus.$off('schema_loaded');
    Bus.$off('refresh_schema');
    Bus.$off('refresh_schemas');
  },
};
